export default {
  xlarge: 32,
  mlarge: 24,
  large: 20,
  medium: 16,
  normal: 12,
  small: 8,
  xsmall: 4,
  narrow: 2,
}